import React from 'react'
import { Link } from 'react-router-dom';
import { ImageLink } from '../constants';

const Footer = ({ settingData, socialData }) => {

    const formatAddress = (address,) => {
        return { __html: address?.replace(/\r?\n/g, '<br>') };
    }
    const formatContact = (contactNumber) => {
        return { __html: contactNumber?.replace(/\r?\n/g, '<br>') };
    };

    return (
        <><footer>
            <div className="footer-area footer-bg">
                <div className="container">
                    <div className="footer-top">
                        <div className="row">

                            <div className="col-xl-4 col-md-4 col-sm-5">
                                <div className="footer-widget text-left">
                                    <h3 className="fw-title ">Contact info</h3>
                                    <div className="contact-info-item">
                                        <div className="footer-social d-flex">
                                            <ul className="footer-list-wrap">
                                                <li className="footer-link d-flex">
                                                    <i className="fas fa-map-marker-alt" />
                                                    <p className="text-white"
                                                        dangerouslySetInnerHTML={formatAddress(
                                                            settingData.headOffice
                                                        )}
                                                    />
                                                </li>
                                                <li className="footer-link d-flex">
                                                    <i className="fas fa-phone-volume" />  <p
                                                        dangerouslySetInnerHTML={formatContact(
                                                            settingData.contactNumber
                                                        )}
                                                    />
                                                </li>
                                                <li className="footer-link d-flex">
                                                    <i className="far fa-envelope-open " />
                                                    <Link className='envelope' to={`mailto:${settingData.contactEmail}`}>
                                                        {settingData.contactEmail}
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-4 col-md-4 col-sm-7">
                                <div className="footer-widget text-center">

                                    <h3 className="fw-title">
                                        {settingData.logo &&
                                            <div className="footer-logo ">
                                                <Link to="/">
                                                    <img loading="auto" src={ImageLink(settingData.logo)} alt='logo_img' />
                                                </Link>

                                            </div>
                                        }</h3>
                                    <div className="footer-social">
                                        <ul className="list-wrap ">
                                            <li className='footer-list'>Crafting exquisite antique gold jewellery that celebrates heritage elegance and timeless beauty since generations</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-4 col-md-4 col-sm-7 text-center">
                                <div className="footer-widget">
                                    <h3 className="fw-title">FOLLOW US</h3>
                                    <div className="footer-social ">
                                        <ul className="list-wrap text-center">
                                            {socialData?.map((item, id) => {
                                                return (
                                                    item.isActive === true && item.showInFooter === true &&
                                                    <li key={id}>
                                                        <Link target='_blank' to={item.url}>
                                                            <i className={item.icon} />
                                                        </Link>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="footer-bottom">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="copyright-text text-center">
                                    <p>
                                        ©{new Date().getFullYear()} Ashapuri Gold Ornament Limited{" "}
                                        <span className="copyright-space">|</span> Website developed by
                                        :{" "}
                                        <Link to="https://www.setblue.com/" target="_blank">
                                            Setblue.com
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer >
        </>
    )
}

export default Footer